<template>
  <RecordViewWrapper>
    <sdPageHeader title="Pegawai">
      <template #subTitle>
        <!-- <sdButton class="btn-add_new" size="default" type="primary">
          <router-link to="/master/pegawai-add"> <sdFeatherIcons type="plus" size="14" /> Tambah</router-link>
        </sdButton> -->
        <sdButton class="btn-download_template" size="default" type="secondary" @click="handleDownloadTemplate($event)">
          <sdFeatherIcons class="mr-2" type="download" size="14" /> Download Template
        </sdButton>
        <sdButton class="btn-import mr-2" size="default" type="primary">
          <router-link to="/assessment/master/pegawai-import">
            <sdFeatherIcons class="mr-2" type="download" size="14" /> Import</router-link
          >
        </sdButton>
        <sdButton class="btn-export" size="default" type="primary" @click="handleExport($event)" :loading="loading">
          <sdFeatherIcons :type="loading ? 'loader' : 'upload'" :class="{ spin: loading }" size="14" />
          {{ loading ? 'Exporting...' : 'Export' }}
        </sdButton>
      </template>

      <template #buttons>
        <div class="search-container">
          <div class="search-box">
            <span class="search-icon">
              <sdFeatherIcons type="search" size="14" />
            </span>
            <a-input
              @input="handleInputChange"
              v-model:value.trim="formState.searchItem"
              type="text"
              name="recored-search"
              placeholder="Search Here"
              class="search-input"
            />
          </div>
        </div>
      </template>
    </sdPageHeader>

    <Main>
      <a-row :gutter="15">
        <a-col class="w-100" :md="24">
          <sdCards headless>
            <div v-if="isLoading" class="spin">
              <a-spin />
            </div>

            <div v-else>
              <TableWrapper class="table-data-view table-responsive">
                <a-table
                  :pagination="{ pageSize: 10, showSizeChanger: true }"
                  :dataSource="dataSource"
                  :columns="columns"
                >
                  <!-- <template #status="{ text }">
                    <a-tag :color="getStatusColor(text)">
                      {{ text }}
                    </a-tag>
                  </template> -->
                </a-table>
              </TableWrapper>
            </div>
          </sdCards>
        </a-col>
      </a-row>
    </Main>
  </RecordViewWrapper>
</template>

<script>
import { RecordViewWrapper } from '../../../../components/crud/style';
import { computed, onMounted, reactive, ref } from 'vue';
import { Main, TableWrapper } from '../../../styled';
import { useStore } from 'vuex';
import { getItem } from '@/utility/localStorageControl';

const ViewPage = {
  name: 'ViewPage',
  components: { RecordViewWrapper, Main, TableWrapper },
  setup() {
    const { state, dispatch } = useStore();
    const crud = computed(() => state.crud.data);
    const isLoading = computed(() => state.crud.loading);
    const profile = getItem('profile_plnbb');
    const permissions = getItem('permissions');

    const checkPermissions = permission => {
      if (profile.roles[0].name == 'Super Admin') {
        return true;
      }

      return permissions.includes(permission);
    };

    const columns = [
      {
        title: 'Nama',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'NIP',
        dataIndex: 'nip',
        key: 'nip',
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
      },
      {
        title: 'Jabatan',
        dataIndex: 'jabatan',
        key: 'jabatan',
      },
      {
        title: 'Jenjang Jabatan',
        dataIndex: 'jenjang_jabatan',
        key: 'jenjang_jabatan',
      },
      {
        title: 'Personal Area',
        dataIndex: 'personal_area',
        key: 'personal_area',
      },
      {
        title: 'Personal Sub Area',
        dataIndex: 'personal_sub_area',
        key: 'personal_sub_area',
      },
      /* {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        slots: { customRender: 'status' },
      }, */
      ...(checkPermissions('update pegawai') || checkPermissions('delete pegawai')
        ? [
            {
              title: 'Actions',
              dataIndex: 'action',
              key: 'action',
              width: '90px',
            },
          ]
        : []),
    ];

    onMounted(() => {
      dispatch('axiosCrudGetData', 'users-assessment2');
    });

    /* const handleUnlock = (id, name) => {
      Modal.confirm({
        title: 'Konfirmasi',
        content: `Apakah Anda yakin ingin membuka kunci proyeksi jabatan ${name}?`,
        okText: 'Unlock',
        cancelText: 'Batal',
        onOk: () => {
          dispatch('axiosDataUnlockProyeksiJabatan', {
            id,
            getData: () => {
              dispatch('axiosCrudGetData', 'users-assessment2');
            },
          });
        },
      });
    }; */

    const formState = reactive({
      searchItem: '',
    });

    /* const getStatusColor = status => {
      switch (status) {
        case 'Aktif':
          return 'green';
        case 'Tidak Aktif':
          return 'red';
        default:
          return 'default';
      }
    }; */

    const dataSource = computed(() =>
      crud.value.length
        ? crud.value.map((data, key) => {
            const { name, nip, email, jabatan, jenjang_jabatan, personal_area, personal_sub_area } = data;

            // const statusDisplay = status === 'ACTV' ? 'Aktif' : status === 'INAC' ? 'Tidak Aktif' : status || '-';

            // const statusColor = status === 'ACTV' ? 'green' : status === 'INAC' ? 'red' : 'default';

            return {
              key: key + 1,
              name: name || '-',
              nip: nip || '-',
              email: email || '-',
              jabatan: jabatan || '-',
              jenjang_jabatan: jenjang_jabatan || '-',
              personal_area: personal_area || '-',
              personal_sub_area: personal_sub_area || '-',
              // status: statusDisplay,
              // statusColor: statusColor,
            };
          })
        : [],
    );

    const handleSearch = () => {
      dispatch('axiosDataSearch', {
        url: 'users-assessment2',
        filter: formState.searchItem,
      });
    };

    const handleInputChange = () => {
      /* if (formState.searchType === 'nik') {
        if (formState.searchItem.length === 16 || formState.searchItem.length === 0) {
          handleSearch();
        }
      } else if (formState.searchType === 'npwp') {
        if (
          formState.searchItem.length === 16 ||
          formState.searchItem.length === 0 ||
          formState.searchItem.length === 15
        ) {
          handleSearch();
        }
      } else { */
      handleSearch();
      // }
    };

    /* const handleSearchTypeChange = () => {
      formState.searchItem = '';
    }; */

    const loading = ref(false);

    const handleDownloadTemplate = event => {
      event.preventDefault();

      dispatch('axiosDownloadTemplate', {
        url: 'download-template-pegawai-assessment',
        fileName: 'Template Import Pegawai Pembinaan Person Grade KEEPInsight.xlsx',
      });
    };

    const handleExport = () => {
      const accessToken = getItem('access_token');
      loading.value = true;

      // Create headers
      const headers = new Headers();
      if (accessToken) {
        headers.append('Authorization', `Bearer ${accessToken}`);
      }
      headers.append('Accept', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      headers.append('Content-Type', 'application/json');

      // Make POST request without credentials
      fetch(`${process.env.VUE_APP_API_ASS}/export-pegawai`, {
        method: 'POST',
        headers,
      })
        .then(response => {
          if (!response.ok) throw new Error('Unauthorized');
          return response.blob();
        })
        .then(blob => {
          // Create download link
          const date = new Date();
          const offset = date.getTimezoneOffset();
          date.setMinutes(date.getMinutes() - offset);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `pegawai_${date
            .toISOString()
            .replace(/[-:T.]/g, '')
            .slice(0, 14)}.xlsx`;
          document.body.appendChild(a);
          a.click();

          // Clean up
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
        .catch(error => {
          this.$message.error('Export failed: ' + error.message);
        })
        .finally(() => {
          loading.value = false;
        });
    };

    return {
      // getStatusColor,
      formState,
      columns,
      isLoading,
      crud,
      dataSource,
      // handleUnlock,
      handleSearch,
      handleInputChange,
      // handleSearchTypeChange,
      handleDownloadTemplate,
      handleExport,
      checkPermissions,
      loading,
    };
  },
};

export default ViewPage;
</script>

<style scoped>
.mr-2 {
  margin-right: 0.5rem;
}

.search-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-select {
  width: 180px;
}

.search-box {
  display: flex;
  align-items: center;
  position: relative;
}

.search-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}

.search-input {
  padding-left: 35px;
}

.spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
